// Angular imports
import { Component, OnInit, ComponentFactoryResolver, ViewChild } from '@angular/core';

// Import service and directive
import { ModalService, ModalOptions } from '../modal.service';
import { ModalDirective } from '../modal.directive';

// Import base modal
import { BaseModalComponent } from '../base-modal';

@Component({
    selector: 'modal-container',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
    @ViewChild(ModalDirective, { static: true }) public _modalHost: ModalDirective;

    public _showModal: boolean = false;

    // Modal info
    public _title: string = '';
    public _closeButtonText: string = '';

    constructor(private modalService: ModalService) {
        // On request to open the modal
        this.modalService._requestModalOpen.subscribe((options: ModalOptions) => {
            // Make sure we're only opening one modal at a time
            if (this._showModal)
                throw new Error('Received request to open modal while another modal is already open. Only one modal can be opened at a time.');

            // Load the modal component into the component host
            const modalComponentRef = this.loadModal(options.modal);

            // Get modal info
            this._title = modalComponentRef.instance.title;
            this._closeButtonText = modalComponentRef.instance.closeButtonText;

            // Initialize the component
            modalComponentRef.instance.init(options.args);

            // Refresh modal info after init
            this._title = modalComponentRef.instance.title;
            this._closeButtonText = modalComponentRef.instance.closeButtonText;

            // Set modal showing
            this._showModal = true;
        });

        // On request to close the modal
        this.modalService._requestModalClose.subscribe(() => {
            // Make sure there is a modal open that we can close
            if (!this._showModal)
                throw new Error('Received request to close modal while there is no modal open.');

            // Set modal to no longer show
            this._showModal = false;
        });
    }

    ngOnInit() {
    }

    public _close() {
        // Check if a modal is open
        if (!this._showModal) return;

        // Close the current modal 
        this.modalService.close();
    }

    public _captureEvent(event: Event) {
        // Stop further event propagation
        event.stopPropagation();
    }

    private loadModal(modalType: typeof BaseModalComponent) {
        // Generate the component factory
        // const componentFactory = this.componentFactoryResolver.resolveComponentFactory<BaseModalComponent>(modalType);

        // Get the view container ref and clear it
        const viewContainerRef = this._modalHost.viewContainerRef;
        viewContainerRef.clear();

        // Create the modal component and return a reference to the component
        return viewContainerRef.createComponent(modalType);
    }
    
    /**
     * Stopping key down event from bubbling to calculation
     * Calculation fields try to set focus if selected after keydown
     * This also happens when a modal popup window is active
     * So we have to prevent it
     * @param event 
     */
    public _onKeydownCode(event: KeyboardEvent) {
        // Prevent event bubbling to underlying calcuation
        event.stopPropagation();

        if (event.key === 'Escape') {
            this._close();
        }
    }
}
